<template>
  <div class="q-pa-xs">
    <div class="col-12 q-mt-lg">
      <q-table
        grid
        :columns="columns"
        :rows="pt.responsaveis"
        row-key="uuid"
        dense
        hide-pagination
        :no-data-label="
          pt.responsaveis ? '' : 'Nenhum Responsável de Encerramento Adicionado'
        "
      >
        <template v-slot:item="props">
          <div style="width: 203px" class="table-desktop">
            <div v-if="props.row.assinaturas && props.row.assinaturas[1]">
              <q-img
                v-if="props.row.assinaturas[1].assinaturaTipo == 'manual'"
                :src="props.row.assinaturas[1].assinatura"
                class="row border-img"
                spinner-color="white"
                height="185px"
                width="185px"
                fit="contain"
                no-native-menu
                :style="{
                  display: props.row.ocultarAssinatura ? 'none' : 'block',
                }"
              >
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'encerrado'
                      : pt.status != 'encerrado' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 1px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="
                    assinaturaResponsavelEncerramento(
                      ptId,
                      props.row.responsavelId
                    )
                  "
                />
                <q-btn
                  v-if="props.row.assinaturas"
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  :icon="
                    props.row.ocultarAssinatura
                      ? 'visibility'
                      : 'visibility_off'
                  "
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary">
                    {{
                      props.row.ocultarAssinatura
                        ? "Mostrar Assinatura"
                        : "Ocultar Assinatura"
                    }}
                  </q-tooltip>
                </q-btn>
                <q-btn
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  disable
                  size="md"
                  icon="delete"
                />
              </q-img>

              <q-img
                v-if="
                  props.row.assinaturas[1].assinaturaTipo == 'manual' &&
                  props.row.ocultarAssinatura
                "
                class="border-img container"
                no-native-menu
              >
                <span class="text-brand-5 text-weight-bold teste2"
                  >Assinatura Oculta</span
                >
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'encerrado'
                      : pt.status != 'encerrado' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 1px"
                  text-color="dark"
                  flat
                  round
                  size="md"
                  icon="history_edu"
                  @click="
                    assinaturaResponsavelEncerramento(
                      ptId,
                      props.row.responsavelId
                    )
                  "
                />
                <q-btn
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary">Mostrar Assinatura</q-tooltip>
                </q-btn>
                <q-btn
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  flat
                  round
                  size="md"
                  icon="delete"
                  disable
                />
              </q-img>

              <q-img
                v-if="
                  ['biometrica', 'facial'].includes(
                    props.row.assinaturas[1].assinaturaTipo
                  ) &&
                  props.row.mostrandoAssinatura &&
                  props.row.assinaturaImagem
                "
                :src="props.row.assinaturaImagem"
                class="row border-img"
                spinner-color="white"
                height="185px"
                width="185px"
                fit="contain"
                no-native-menu
              >
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'encerrado'
                      : pt.status != 'encerrado' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 1px"
                  text-color="dark"
                  flat
                  round
                  size="md"
                  icon="history_edu"
                  @click="
                    assinaturaResponsavelEncerramento(
                      ptId,
                      props.row.responsavelId
                    )
                  "
                />
                <q-btn
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility_off"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary">Ocultar Assinatura</q-tooltip>
                </q-btn>
                <q-btn
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  flat
                  round
                  size="md"
                  icon="delete"
                  disable
                />
              </q-img>

              <q-img
                v-if="props.row.assinaturas[1].assinaturaTipo == 'eletronica'"
                class="border-img container"
                no-native-menu
              >
                <span class="text-brand-5 text-weight-bold teste2"
                  >Assinatura Eletrônica
                </span>
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'encerrado'
                      : pt.status != 'encerrado' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 1px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="
                    assinaturaResponsavelEncerramento(
                      ptId,
                      props.row.responsavelId
                    )
                  "
                />
                <q-btn
                  v-if="props.row.assinaturas"
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary"
                    >Visualizar Assinatura</q-tooltip
                  >
                </q-btn>
                <q-btn
                  disable
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                />
              </q-img>

              <q-img
                v-else-if="
                  ['biometrica', 'pin', 'token', 'facial', 'cracha'].includes(
                    props.row.assinaturas[1].assinaturaTipo
                  ) &&
                  (!props.row.mostrandoAssinatura ||
                    props.row.carregandoAssinatura)
                "
                class="border-img container"
                no-native-menu
              >
                <div
                  v-if="props.row.carregandoAssinatura"
                  class="loading-overlay"
                >
                  <q-spinner color="primary" size="2em" />
                  <span class="text-brand-5 text-weight-bold loading-text"
                    >Carregando...</span
                  >
                </div>
                <span v-else class="text-brand-5 text-weight-bold teste2">
                  {{
                    props.row.assinaturas[1].assinaturaTipo === "cracha"
                      ? "Autenticado por Crachá"
                      : props.row.assinaturas[1].assinaturaTipo === "facial"
                      ? "Biometria Facial"
                      : props.row.assinaturas[1].assinaturaTipo === "biometrica"
                      ? "Biometria Digital"
                      : props.row.assinaturas[1].assinaturaTipo === "pin"
                      ? "Autenticado por PIN"
                      : props.row.assinaturas[1].assinaturaTipo === "token"
                      ? "Autenticado por Token"
                      : "Assinado Eletrônicamente"
                  }}
                </span>
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'encerrado'
                      : pt.status != 'encerrado' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 1px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="
                    assinaturaResponsavelEncerramento(
                      ptId,
                      props.row.responsavelId
                    )
                  "
                />
                <q-btn
                  v-if="props.row.assinaturas"
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility"
                  :loading="props.row.carregandoAssinatura"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary"
                    >Visualizar Assinatura</q-tooltip
                  >
                </q-btn>
                <q-btn
                  disable
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                />
              </q-img>
              <div
                class="row col-12 q-mt-sm items-center"
                style="background: #e8ffec; width: 90%"
              >
                <span class="elipse q-mr-sm bg-positive"></span>
                <span class="text-weight-bold text-brand-5 texto-assinatura">
                  Assinatura Coletada</span
                >
              </div>
            </div>

            <div v-else>
              <q-img class="border-img container" no-native-menu>
                <span
                  class="text-brand-5 text-weight-bold teste"
                  style="font-size: 18px"
                  >Sem Assinatura</span
                >
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'encerrado'
                      : pt.status != 'encerrado' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 1px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="
                    assinaturaResponsavelEncerramento(
                      ptId,
                      props.row.responsavelId
                    )
                  "
                />
                <q-btn
                  disable
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                />
              </q-img>
              <div
                class="row col-12 q-mt-sm items-center"
                style="background: #ffe9e9; width: 90%"
              >
                <span class="elipse q-mr-sm bg-red"></span>
                <span class="text-weight-bold text-red texto-assinatura">
                  Assinatura NÃO Coletada</span
                >
              </div>
            </div>

            <q-card-section
              style="width: 200px; margin-top: 5px; padding: 0"
              class="row text-weight-regular text-body2"
            >
              <div class="column text-brand-5 text-weight-regular">
                <span class="q-mb-sm">{{ props.row.nome }}</span>

                <span class="q-mb-sm text-brand-5 text-weight-bold">
                  <div class="text-brand-5 text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">
                      Matricula:
                    </div>
                    {{ props.row.matricula }}
                  </div>
                </span>

                <span class="q-mb-sm text-brand-5 text-weight-bold">
                  <div class="text-brand-5 text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">Tipo:</div>
                    {{ props.row.tipo }}
                  </div>
                </span>

                <span class="q-mb-sm text-brand-5 text-weight-bold">
                  <div class="text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">
                      Empresa:
                    </div>
                    {{ props.row.empresa }}
                  </div>
                </span>

                <span class="text-brand-5 text-weight-bold">
                  <div class="text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">
                      Terceirizado:
                    </div>
                    {{ props.row.terceirizado ? "Sim" : "Não" }}
                  </div>
                </span>
              </div>
            </q-card-section>
          </div>
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4 mobileGrid">
            <div class="row card q-mb-md justify-around">
              <div class="col-7 q-mr-sm q-mt-sm">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div
                    class="row col-12"
                    style="background: #e8ffec; width: 90%"
                    v-if="props.row.assinaturas && props.row.assinaturas[1]"
                  >
                    <span class="elipse q-mr-sm bg-positive"></span>
                    <span
                      class="text-weight-bold text-brand-5 texto-assinatura"
                    >
                      Assinatura Coletada</span
                    >
                  </div>
                  <div
                    class="row col-12"
                    style="background: #ffe9e9; width: 90%"
                    v-else
                  >
                    <span class="elipse q-mr-sm bg-red"></span>
                    <span class="text-weight-bold text-red texto-assinatura">
                      Assinatura NÃO Coletada</span
                    >
                  </div>
                  <div class="col-12">
                    <span> {{ props.row.nome }}</span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Matricula:</strong>
                      {{ props.row.matricula }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span><strong>Tipo:</strong> {{ props.row.tipo }}</span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Terceiro:</strong>
                      {{ props.row.terceirizado ? "Sim" : "Não" }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Empresa:</strong>
                      {{
                        props.row.tipo == "emissor"
                          ? pt.empresa
                          : props.row.empresa
                      }}</span
                    >
                  </div>
                </q-card-section>
              </div>
              <div
                class="col q-ml-md justify-center q-mt-md text-brand-5 text-weight-bold text-grid-table"
              >
                <div class="q-ml-lg">Assinatura</div>
                <div
                  style="width: 110px; height: 70px"
                  class="row items-center justify-center"
                >
                  <q-img
                    v-if="
                      props.row.assinaturas &&
                      props.row.assinaturas[1] &&
                      props.row.assinaturas[1].assinaturaTipo == 'manual'
                    "
                    :src="
                      props.row.assinaturas[1]
                        ? props.row.assinaturas[1].assinatura
                        : ''
                    "
                    spinner-color="white"
                  />
                  <q-img
                    v-else-if="
                      props.row.assinaturas &&
                      props.row.assinaturas[1] &&
                      ['biometria', 'facial'].includes(
                        props.row.assinaturas[1].assinaturaTipo
                      ) &&
                      props.row.mostrandoAssinatura &&
                      props.row.assinaturaImagem
                    "
                    :src="props.row.assinaturaImagem"
                    spinner-color="white"
                    fit="contain"
                  />
                  <span
                    style="font-size: 10px"
                    v-else-if="
                      props.row.assinaturas &&
                      props.row.assinaturas[1] &&
                      props.row.assinaturas[1].assinaturaTipo == 'eletronica'
                    "
                    >Assinatura Eletrônica</span
                  >
                  <span
                    style="font-size: 10px"
                    v-else-if="
                      props.row.assinaturas &&
                      props.row.assinaturas[1] &&
                      [
                        'biometrica',
                        'pin',
                        'token',
                        'facial',
                        'cracha',
                      ].includes(props.row.assinaturas[1].assinaturaTipo)
                    "
                  >
                    {{
                      props.row.assinaturas[1].assinaturaTipo === "cracha"
                        ? "Autenticado por Crachá"
                        : props.row.assinaturas[1].assinaturaTipo === "facial"
                        ? "Biometria Facial"
                        : props.row.assinaturas[1].assinaturaTipo ===
                          "biometrica"
                        ? "Biometria Digital"
                        : props.row.assinaturas[1].assinaturaTipo === "pin"
                        ? "Autenticado por PIN"
                        : props.row.assinaturas[1].assinaturaTipo === "token"
                        ? "Autenticado por Token"
                        : "Assinatura Eletrônica"
                    }}
                  </span>
                </div>
              </div>
              <div class="row col-12">
                <div class="column col-4">
                  <q-btn
                    :disable="
                      usuarioPodeEditar
                        ? pt.status != 'encerrado'
                        : pt.status != 'encerrado' ||
                          usuario != props.row.matricula
                    "
                    class="btn-grid"
                    label="Assinatura"
                    icon="history_edu"
                    stack
                    style="background: #393939; color: white"
                    no-caps
                    @click="
                      assinaturaResponsavelEncerramento(
                        ptId,
                        props.row.responsavelId
                      )
                    "
                  />
                </div>
                <div
                  class="column col-4"
                  v-if="props.row.assinaturas && props.row.assinaturas[1]"
                >
                  <q-btn
                    class="btn-grid"
                    :label="
                      props.row.assinaturas[1].assinaturaTipo === 'manual'
                        ? props.row.ocultarAssinatura
                          ? 'Mostrar'
                          : 'Ocultar'
                        : props.row.mostrandoAssinatura
                        ? 'Ocultar'
                        : 'Ver'
                    "
                    icon="visibility"
                    stack
                    style="background: #1976d2; color: white"
                    no-caps
                    @click="toggleAssinaturaView(props.row)"
                  />
                </div>
                <div class="column col-4">
                  <q-btn
                    disable
                    class="btn-grid"
                    label="Deletar"
                    icon="delete"
                    stack
                    style="background: #cf1515; color: white"
                    no-caps
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { watch } from "vue";

const columns = [
  {
    name: "nome",
    align: "left",
    label: "Nome",
    field: "nome",
    sortable: true,
  },

  {
    name: "assinaturas",
    label: "Assinaturas",
    align: "center",
    field: "responsavelId",
    sortable: false,
  },
];

export default {
  props: ["pt", "usuarioPodeEditar"],
  emits: ["responsaveisAtualizados"],

  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const usuario = store.getters["autenticacao/usuarioLogado"].id;

    const removerResponsavel = async (responsavelId) => {
      try {
        await store.dispatch("pdt/removerResponsavelPt", {
          ptId: props.pt.ptId,
          responsavelId,
        });

        quasar.notify({
          message: "Responsavel removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("responsaveisAtualizados");
      } catch (error) {
        quasar.notify({
          message: "Ocorreu um erro ao remover responsavel",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    const assinaturaResponsavelEncerramento = (ptId, responsavelId) => {
      router.push({
        name: "pdt-pt-assinatura-encerramento",
        params: ({ ptId }, { responsavelId }),
      });
    };

    // Função para inicializar propriedades reativas nos responsáveis
    const inicializarPropriedadesResponsavel = (responsavel) => {
      if (responsavel.assinaturas && responsavel.assinaturas[1]) {
        const assinaturaTipo = responsavel.assinaturas[1].assinaturaTipo;

        // Inicializar propriedades se não existirem
        if (
          !Object.prototype.hasOwnProperty.call(
            responsavel,
            "ocultarAssinatura"
          )
        ) {
          responsavel.ocultarAssinatura = false;
        }

        if (
          !Object.prototype.hasOwnProperty.call(
            responsavel,
            "mostrandoAssinatura"
          )
        ) {
          responsavel.mostrandoAssinatura = false;
        }

        if (
          !Object.prototype.hasOwnProperty.call(
            responsavel,
            "carregandoAssinatura"
          )
        ) {
          responsavel.carregandoAssinatura = false;
        }

        if (
          !Object.prototype.hasOwnProperty.call(responsavel, "erroAssinatura")
        ) {
          responsavel.erroAssinatura = false;
        }

        if (
          !Object.prototype.hasOwnProperty.call(responsavel, "assinaturaImagem")
        ) {
          responsavel.assinaturaImagem = null;
        }

        // Forçar que biometria/facial SEMPRE começem no estado de texto
        if (["biometria", "facial"].includes(assinaturaTipo)) {
          responsavel.mostrandoAssinatura = false;
          responsavel.assinaturaImagem = null;
          responsavel.carregandoAssinatura = false;
          responsavel.erroAssinatura = false;
        }
      }
    };

    // Inicializar propriedades para todos os responsáveis existentes
    if (props.pt && props.pt.responsaveis) {
      props.pt.responsaveis.forEach((responsavel) => {
        inicializarPropriedadesResponsavel(responsavel);
      });
    }

    // Watcher para observar mudanças nos responsáveis e inicializar propriedades quando necessário
    watch(
      () => props.pt?.responsaveis,
      (newResponsaveis) => {
        if (newResponsaveis) {
          newResponsaveis.forEach((responsavel) => {
            inicializarPropriedadesResponsavel(responsavel);

            // Forçar biometrias recém-adicionadas ao estado correto
            if (responsavel.assinaturas && responsavel.assinaturas[1]) {
              const tipo = responsavel.assinaturas[1].assinaturaTipo;
              if (["biometria", "facial"].includes(tipo)) {
                responsavel.mostrandoAssinatura = false;
                responsavel.assinaturaImagem = null;
                responsavel.carregandoAssinatura = false;
              }
            }
          });
        }
      },
      { immediate: true, deep: true }
    );

    const toggleAssinaturaView = async (responsavel) => {
      // Garantir que as propriedades estão inicializadas
      inicializarPropriedadesResponsavel(responsavel);
      if (!responsavel.assinaturas || !responsavel.assinaturas[1]) {
        return;
      }

      const assinatura = responsavel.assinaturas[1];

      if (assinatura.assinaturaTipo === "manual") {
        responsavel.ocultarAssinatura = !responsavel.ocultarAssinatura;
        return;
      }

      if (responsavel.mostrandoAssinatura) {
        responsavel.mostrandoAssinatura = false;
        return;
      }

      if (["biometrica", "facial"].includes(assinatura.assinaturaTipo)) {
        responsavel.carregandoAssinatura = true;
        responsavel.erroAssinatura = false;

        try {
          const response = await store.dispatch("pdt/getImage", {
            url: assinatura.assinatura,
          });

          responsavel.assinaturaImagem = response.data.resultado.dados;
          responsavel.mostrandoAssinatura = true;
        } catch (error) {
          console.log(error);
          responsavel.erroAssinatura = true;

          quasar.notify({
            message: "Erro ao visualizar imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
        } finally {
          responsavel.carregandoAssinatura = false;
        }
      } else {
        responsavel.mostrandoAssinatura = true;
      }
    };

    return {
      columns,
      removerResponsavel,
      assinaturaResponsavelEncerramento,
      toggleAssinaturaView,
      usuario,
    };
  },
};
</script>

<style scoped>
img {
  height: 185px;
  width: 185px;
}
.border-img {
  border: 1px solid #b4b4b4;
  border-radius: 5px;
  height: 185px;
  width: 185px;
}
.cursor {
  cursor: pointer;
}
.texto {
  display: inline;
}
.container {
  position: relative;
}
.teste {
  position: absolute;
  top: 75px;
  left: 22px;
  opacity: 0.6;
}
.teste2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  font-size: 15px;
  text-align: center;
  width: 90%;
}
.teste2-centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  font-size: 15px;
}
.loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: #1976d2;
  text-align: center;
}
.mobileGrid {
  display: none;
}
.texto-assinatura {
  font-size: 13px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
@media (max-width: 600px) {
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid {
    font-size: 12px;
    border-radius: 0px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .mobileGrid {
    display: block;
  }
  .table-desktop {
    display: none;
  }
  .texto-assinatura {
    font-size: 10px;
  }
  .elipse {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    padding: 0px;
    margin: 2px 5px 0px 0px;
  }
}
</style>
